import Spin from 'antd/es/spin';
import { styled } from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100%;
`;

export const CenterSpin = () => {
  return (
    <StyledContainer>
      <Spin size="large" />
    </StyledContainer>
  );
};

export default CenterSpin;
